import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import Button from '../../components/atoms/Button';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import FacebookIcon from '../../resources/svg/partners/facebook.svg';
import { TRANSLATION_KEY } from '../constants';
import { userMcpConnectionShape } from '../propShapes';
import css from './UserMcpConnectionControl.css';

const PROVIDER_ICONS = {
    meta: FacebookIcon,
};

const UserMcpConnectionControl = ({ connection, busy = false, onConnect, onDisconnect, translate }) => {
    if (!connection.available) return null;

    const { provider, display_name: providerName, connected, expired } = connection;
    const ProviderIcon = PROVIDER_ICONS[provider];

    if (!connected || expired)
        return (
            <Button
                type={expired ? 'attention' : 'secondary'}
                Icon={ProviderIcon}
                showSpinner={busy}
                onClick={() => onConnect(provider)}
            >
                <Translate id={`${TRANSLATION_KEY}.${expired ? 'RECONNECT' : 'CONNECT'}`} data={{ providerName }} />
            </Button>
        );

    return (
        <div className={css.connected}>
            {ProviderIcon && <ProviderIcon className={css.providerIcon} />}
            <span className={css.providerName}>{providerName}</span>
            <button
                type="button"
                className={css.disconnect}
                disabled={busy}
                aria-label={translate(`${TRANSLATION_KEY}.DISCONNECT_LABEL`, { providerName })}
                onClick={() => onDisconnect(provider)}
            >
                <Icon name="unlink" size={IconSizes.SMALL} interactive={false}
                    className={css.disconnectIcon} hoverText={`${TRANSLATION_KEY}.DISCONNECT_TOOLTIP`} />
            </button>
        </div>
    );
};

UserMcpConnectionControl.propTypes = {
    connection: userMcpConnectionShape.isRequired,
    busy: PropTypes.bool,
    onConnect: PropTypes.func.isRequired,
    onDisconnect: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(UserMcpConnectionControl);
